module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('header', {
    staticClass: "circleHeader",
    style: (_vm.success ? {
      marginBottom: '70px'
    } : '')
  }, [_c('h2', [_vm._v(_vm._s(_vm.contact.title))])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.contact.content)
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b5a3c94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/Contact.vue
// module id = 794
// module chunks = 1